<template>
  <div class="row for-authors-style-guide">
    <!--Non-Mobile Only-->
    <div class="col-md-3 hidden-sm-down">
      <for-authors-page-side-menu :anchors-list="anchorsList"></for-authors-page-side-menu>
    </div>
    <!--Non-Mobile Only-->
    <div class="col-md">
      <for-authors-style-guide-content :anchors-list="anchorsList"></for-authors-style-guide-content>
    </div>
  </div>
</template>

<script>
  import ForAuthorsPageSideMenu from '@/components/for-authors/ForAuthorsPageSideMenu'
  import ForAuthorsStyleGuideContent from '@/components/for-authors/for-authors-style-guide/ForAutorsStyleGuideContent'

  export default {
    components: {
      ForAuthorsPageSideMenu,
      ForAuthorsStyleGuideContent
    },
    name: 'for-authors-style-guide',
    data () {
      return {
        anchorsList: [
          {anchor: 'research', name: 'Research'},
          {anchor: 'editorial', name: 'Editorial'},
          {anchor: 'review', name: 'Review'},
          {anchor: 'book-reader', name: 'Book Reader'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForAutorsStyleGuidePage.vue?64f3d90a